import type {ListFilesParams} from './types/files-types';

export const filesKeys = {
  all: ['files'] as const,

  files: {
    filtered: (tenantId: string, params: ListFilesParams) =>
      [...filesKeys.all, 'list', tenantId, params] as const,
    detail: (id: string, tenantId: string) =>
      [...filesKeys.all, 'detail', id, tenantId] as const,
    contentUrl: (id: string, tenantId: string) =>
      [...filesKeys.all, 'content-url', id, tenantId] as const,
    listPrefix: (tenantId: string) =>
      [...filesKeys.all, 'list', tenantId] as const,
  },

  categories: {
    all: (tenantId: string) =>
      [...filesKeys.all, 'categories', tenantId] as const,
  },
};
